import { ENV } from '../config/env';
import { apiHosts, cclPcHosts, siteHosts } from '../config/env-website';

export const apiHostMain = apiHosts.main[ENV];
export const apiHostSocket = apiHosts.socket[ENV];
export const apiHostMqtt = apiHosts.mqtt[ENV];
export const getSiteHost = siteHosts[ENV];
export const getCclPcHost = cclPcHosts[ENV];
export const apiHostEappweb = apiHosts.eappweb[ENV];
